import React from 'react';

export default function NavBarMobileIconBurger({ isClose, handleClick }) {
  const className = isClose ? 'hamburger hamburger--squeeze is-active' : 'hamburger hamburger--squeeze';

  return (
    <button onClick={handleClick} id="nav-mobile-hamburger" className={className} type="button" aria-label="Navigation button">
      <span className="hamburger-box">
        <span className="hamburger-inner" />
      </span>
    </button>
  );
}
